var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newPopup"},[_c('el-dialog',{attrs:{"show-close":false,"visible":_vm.dialogVisible,"width":"660px","lock-scroll":false,"modal-append-to-body":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"newPopup_diaog",on:{"click":_vm.onclose}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }